import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useGetSectors } from '@/hooks/useGetSectors';
import { SelectOptions } from '@/components/ui/SelectOptions';
import { FormItemWrapper, LabelMediumRegular } from '@/components/Settings/DataExtraction/styles';

const { useFormInstance, useWatch } = Form;

export function SectorFormItem() {
	const form = useFormInstance();
	const organization_id: string = useWatch('organization_id');
	const company_id: string = useWatch('company_id');

	const sectors = useGetSectors({
		organization_id,
		company_id
	});

	function handleOnChange(): void {
		form.setFieldValue(['line_id'], undefined);
		form.setFieldValue(['workstation_id'], undefined);
	}

	const isDisabled: boolean = !organization_id || !company_id;

	return (
		<FormItemWrapper
			name="sector_id"
			label={<LabelMediumRegular>{I18n.get('Sector')}</LabelMediumRegular>}
			labelCol={{ span: 24 }}
		>
			<SelectOptions
				allowClear
				disabled={isDisabled}
				options={sectors.data}
				onChange={handleOnChange}
				loading={sectors.isFetching}
				placeholder={I18n.get('Sector')}
			/>
		</FormItemWrapper>
	);
}
